import { generateEndpointApi, methods } from '@btime/react-api'

export const listMapsLocationEndpoint = generateEndpointApi('maps/list', methods.GET)
